import { Col, Row } from "react-bootstrap";
import { IEdenMessageDetails } from "../../../api/IEdenMessage";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface EdenMessageDetailsProps {
  edenMessage: IEdenMessageDetails;
}

const EdenMessageDetails = ({ edenMessage }: EdenMessageDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Received from Licensee"}
            value={edenMessage.dateraised}
          />
          <EpaField label={"Subject"} value={edenMessage.subject} />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField label={"Date Closed"} value={edenMessage.closeddate} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Message from Licensee"}
            value={edenMessage.message}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Response from EPA"}
            value={edenMessage.response}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Message Details"} content={bodyElements} />;
};

export default EdenMessageDetails;
